import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteDisapprovalReason(shop: ShopDto) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/disapproval-reasons/{reasonId}",
		{
			invalidate: useInvalidateShop(shop.id),
			mapVariables: (reasonId: string) => ({
				params: { path: { shopId: shop.id, reasonId } },
			}),
		},
	);
}
